import GetUser from './GetUser'
import GetSiteRec from './GetSiteRec'

const ValidatePageAccess = async ( siteId, settingKey ) => {
    let userSettings = []
    let projectSettings  = []
    try {
        // Fetch user & project settings
        userSettings = await GetUser() 
        projectSettings  = await GetSiteRec(siteId)
        // Check if user & project settings exist
        if(userSettings['data']['rows'][0]['infSiteModules'] !== undefined && userSettings['data']['rows'][0]['infSiteModules'].length !== 0) userSettings = userSettings['data']['rows'][0]['infSiteModules']
        if(projectSettings['data']['rows'][0]['settings'] !== undefined && projectSettings['data']['rows'][0]['settings'].length !== 0) projectSettings = projectSettings['data']['rows'][0]['settings']
        // Check if user & project have access to page
        if(userSettings.includes(settingKey) && projectSettings.some((setting) => setting['infModuleSettingsKey'].includes(settingKey))) return true 
        else return false
    } catch {
        return false
    }
}

export default ValidatePageAccess